import React, { useEffect, useRef, useState } from "react";
import styles from "./BasicCleanupsFilter.module.scss";
import switchStyles from "../CleanupsFilter.module.scss";
import BasicBrownfieldFilter from "./BasicBrownfieldFilter/BasicBrownfieldFilter";
import BasicFederalFacilitiesFilter from "./BasicFederalFacilitiesFilter/BasicFederalFacilitiesFilter";
import BasicHazardWasteFilter from "./BasicHazardWasteFilter/BasicHazardWasteFilter";
import BasicIncidentCategoryFilter from "./BasicIncidentCategoryFilter/BasicIncidentCategoryFilter";
import BasicNationalSignificanceFilter from "./BasicNationalSignificanceFilter/BasicNationalSignificanceFilter";
import BasicRCRAFilter from "./BasicRCRAFilter/BasicRCRAFilter";
import BasicRecoveryActFilter from "./BasicRecoveryActFilter/BasicRecoveryActFilter";
import BasicResponseAuthorityFilter from "./BasicResponseAuthorityFilter/BasicResponseAuthorityFilter";
import BasicResponseStatusFilter from "./BasicResponseStatusFilter/BasicResponseStatusFilter";
import BasicResponseTypeFilter from "./BasicResponseTypeFilter/BasicResponseTypeFilter";
import BasicSuperfundNPLFilter from "./BasicSuperfundNPLFilter/BasicSuperfundNPLFilter";
import BasicSuperfundNonNPLFilter from "./BasicSuperfundNonNPLFilter/BasicSuperfundNonNPLFilter";
import {
  CalciteButton,
  CalcitePanel,
  CalciteSwitch,
} from "@esri/calcite-components-react";
// import config from "../../../assets/config.json";

const BasicCleanupsFilter = (props) => {
  const brownfieldParams = useRef<Array<any>>([]);
  const facilitiesParams = useRef<Array<any>>([]);
  const federalHazardWasteParams = useRef<Array<any>>([]);
  const incidentCategoryParams = useRef<Array<any>>([]);
  const natlSignificanceParams = useRef<Array<any>>([]);
  const rcraParams = useRef<Array<any>>([]);
  const recoveryActParams = useRef<Array<any>>([]);
  const responseAuthorityParams = useRef<Array<any>>([]);
  const responseStatusParams = useRef<Array<any>>([]);
  const responseTypeParams = useRef<Array<any>>([]);
  const superfundNPLParams = useRef<Array<any>>([]);
  const superfundNonNPLParams = useRef<Array<any>>([]);
  const componentIsLoaded = useRef<boolean>(false);
  const [checkAllBoxes, setCheckAllBoxes] = useState<boolean>(
    props.siteType !== null ? false : true
  );
  const [signalAChange, setSignalAChange] = useState(Math.random());
  const [toggleOrClear, setToggleOrClear] = useState<string>("toggle");

  // will need one of these functions for each different component
  const updateBrownfieldParams = (paramArray) => {
    brownfieldParams.current = paramArray;
  };

  const updateRCRAParams = (paramArray) => {
    rcraParams.current = paramArray;
  };

  const updateSuperfundNPLParams = (paramArray) => {
    superfundNPLParams.current = paramArray;
  };

  const updateSuperfundNonNPLParams = (paramArray) => {
    superfundNonNPLParams.current = paramArray;
  };

  const updateResponseAuthorityParams = (paramArray) => {
    responseAuthorityParams.current = paramArray;
  };

  const updateResponseStatusParams = (paramArray) => {
    responseStatusParams.current = paramArray;
  };

  const updateResponseTypeParams = (paramArray) => {
    responseTypeParams.current = paramArray;
  };

  const updateIncidentCategoryParams = (paramArray) => {
    incidentCategoryParams.current = paramArray;
  };

  const updateFacilitiesParams = (paramArray) => {
    facilitiesParams.current = paramArray;
  };

  const updateFederalHazardWasteParams = (paramArray) => {
    federalHazardWasteParams.current = paramArray;
  };

  const updateRecoveryActParams = (paramArray) => {
    recoveryActParams.current = paramArray;
  };

  const updateNatlSignificanceParams = (paramArray) => {
    natlSignificanceParams.current = paramArray;
  };

  const clearAllParams = (togglingFromSwitch?: boolean) => {
    setCheckAllBoxes(false);
    setSignalAChange(Math.random());
    brownfieldParams.current =
      facilitiesParams.current =
      incidentCategoryParams.current =
      federalHazardWasteParams.current =
      natlSignificanceParams.current =
      rcraParams.current =
      recoveryActParams.current =
      responseAuthorityParams.current =
      responseStatusParams.current =
      responseTypeParams.current =
      superfundNPLParams.current =
      superfundNonNPLParams.current =
        [];
    setToggleOrClear("clear");
    if (togglingFromSwitch) {
      props.generalClearAll();
    }
  };

  const toggleAllParams = (togglingFromSwitch?: boolean) => {
    setCheckAllBoxes(true);
    setSignalAChange(Math.random());
    setToggleOrClear("toggle");
    if (togglingFromSwitch) {
      props.generalToggleAll();
    }
  };

  const createWhereString = () => {
    const paramArray: Array<any> = [
      ...brownfieldParams.current,
      ...facilitiesParams.current,
      ...federalHazardWasteParams.current,
      ...incidentCategoryParams.current,
      ...natlSignificanceParams.current,
      ...rcraParams.current,
      ...recoveryActParams.current,
      ...responseAuthorityParams.current,
      ...responseStatusParams.current,
      ...responseTypeParams.current,
      ...superfundNPLParams.current,
      ...superfundNonNPLParams.current,
    ];
    if (paramArray.length > 0) {
      // const whereString = "(" + paramArray.join(") OR (") + ")";
      props.generalSetLayerViewFilter(`(${paramArray.join(") OR (")})`, 'basic');
    } else {
      props.generalClearAll();
    }
  };

  useEffect(() => {
    if (componentIsLoaded.current) clearAllParams(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.shouldClear]);

  useEffect(() => {
    if (componentIsLoaded.current) toggleAllParams(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.shouldToggle]);
  
  useEffect(() => {
    componentIsLoaded.current = true;
  }, [checkAllBoxes, signalAChange, toggleOrClear]);

  return (
    <>
      <div>
        <div className={switchStyles.controlsDiv}>
          <CalciteButton
            className={styles.FilterAndZoomButtons}
            onClick={() => {
              createWhereString();
            }}
            iconStart={"layer-filter"}
          >
            Filter
          </CalciteButton>
          <div className={switchStyles.toggleSwitchDiv}>
            <label className={switchStyles.toggleLabel}>
              Toggle All Cleanups
            </label>
            {toggleOrClear === "clear" && (
              <CalciteSwitch
                onCalciteSwitchChange={() => {
                  toggleAllParams(true);
                }}
              />
            )}
            {toggleOrClear === "toggle" && (
              <CalciteSwitch
                checked
                onCalciteSwitchChange={() => {
                  clearAllParams(true);
                }}
              />
            )}
          </div>
        </div>

        {/* standard section */}
        <CalcitePanel className={styles.ParentPanels}>
          <label className={styles.SectionLabels}>
            Brownfield, RCRA, and Superfund filters
          </label>

          <div className={styles.SectionContainers}>
            <div className={styles.TopSectionInThirds}>
              <BasicBrownfieldFilter
                sitesLayer={props.sitesLayer}
                updateBrownfieldParams={updateBrownfieldParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
                customRouteUsed={props.siteType === "brownfields"}
                updateDefinitionExpression={() => {
                  // updateDefinitionExpression();
                  createWhereString();
                }}
              />
            </div>
            <div className={styles.TopSectionInThirds}>
              <BasicRCRAFilter
                sitesLayer={props.sitesLayer}
                updateRCRAParams={updateRCRAParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
                customRouteUsed={props.siteType === "rcra"}
                updateDefinitionExpression={() => {
                  // updateDefinitionExpression();
                  createWhereString();
                }}
              />
            </div>

            <div className={styles.TopSectionInThirds}>
              <div className={styles.VerticalStackContainers}>
                <BasicSuperfundNPLFilter
                  sitesLayer={props.sitesLayer}
                  updateSuperfundNPLParams={updateSuperfundNPLParams}
                  checkAllBoxes={checkAllBoxes}
                  signalAChange={signalAChange}
                  customRouteUsed={props.siteType === "superfund"}
                  updateDefinitionExpression={() => {
                    // updateDefinitionExpression();
                    createWhereString();
                  }}
                />
                <BasicSuperfundNonNPLFilter
                  sitesLayer={props.sitesLayer}
                  updateSuperfundNonNPLParams={updateSuperfundNonNPLParams}
                  checkAllBoxes={checkAllBoxes}
                  signalAChange={signalAChange}
                  customRouteUsed={props.siteType === "superfund"}
                  updateDefinitionExpression={() => {
                    // updateDefinitionExpression();
                    createWhereString();
                  }}
                />
              </div>
            </div>
          </div>
        </CalcitePanel>

        {/* response sections */}
        <CalcitePanel className={styles.ParentPanels}>
          <label className={styles.SectionLabels}>Responses</label>
          <div className={styles.SectionContainers}>
            <div className={styles.VerticalStackContainers}>
              <BasicResponseTypeFilter
                sitesLayer={props.sitesLayer}
                updateResponseTypeParams={updateResponseTypeParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
              />
              <BasicResponseStatusFilter
                sitesLayer={props.sitesLayer}
                updateResponseStatusParams={updateResponseStatusParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
              />
            </div>
            <div className={styles.VerticalStackContainers}>
              <BasicIncidentCategoryFilter
                sitesLayer={props.sitesLayer}
                updateIncidentCategoryParams={updateIncidentCategoryParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
                customRouteUsed={props.siteType === "removals"}
                updateDefinitionExpression={() => {
                  // updateDefinitionExpression();
                  createWhereString();
                }}
              />
              <BasicResponseAuthorityFilter
                sitesLayer={props.sitesLayer}
                updateResponseAuthorityParams={updateResponseAuthorityParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
              />
            </div>
          </div>
        </CalcitePanel>

        {/* third section */}
        <CalcitePanel className={styles.ParentPanels}>
          <div className={styles.SectionContainers}>
            <div className={styles.VerticalStackContainers}>
              <BasicFederalFacilitiesFilter
                sitesLayer={props.sitesLayer}
                updateFacilitiesParams={updateFacilitiesParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
                customRouteUsed={props.siteType === "federalfacilities"}
                updateDefinitionExpression={() => {
                  // updateDefinitionExpression();
                  createWhereString();
                }}
              />
              <BasicRecoveryActFilter
                sitesLayer={props.sitesLayer}
                updateRecoveryActParams={updateRecoveryActParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
                customRouteUsed={props.siteType === "recovery"}
                updateDefinitionExpression={() => {
                  // updateDefinitionExpression();
                  createWhereString();
                }}
              />
            </div>
            <div className={styles.VerticalStackContainers}>
              <BasicHazardWasteFilter
                sitesLayer={props.sitesLayer}
                updateFederalHazardWasteParams={updateFederalHazardWasteParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
                customRouteUsed={props.siteType === "docket"}
                updateDefinitionExpression={() => {
                  // updateDefinitionExpression();
                  createWhereString();
                }}
              />
              <BasicNationalSignificanceFilter
                sitesLayer={props.sitesLayer}
                updateNatlSignificanceParams={updateNatlSignificanceParams}
                checkAllBoxes={checkAllBoxes}
                signalAChange={signalAChange}
              />
            </div>
          </div>
        </CalcitePanel>
      </div>
    </>
  );
};

export default BasicCleanupsFilter;
